<div class="complex-filter" [ngClass]="'complex-filter--' + nestingDisplayMode">
  <div class="complex-filter__header">
    <h2>Filters</h2>
    <a href class="link complex-filter__clear-all" (click)="$event.preventDefault(); clearAll()">Clear all</a>
  </div>

  <div class="complex-filter__body">
    @for (section of config; track section) {
      <div
        class="complex-filter__section"
        [ngClass]="section.modalOnly ? 'complex-filter__section--' + section.modalOnly : ''"
      >
        @for (subsection of section.subsections; track subsection) {
          <div class="complex-filter__subsection">
            @if (subsection.title) {
              <span class="complex-filter__subsection__title">{{ subsection.title }}</span>
            }
            @for (filter of subsection.filters; track filter) {
              @if (
                (!filter.isEnabled || (filter.isEnabled | async)) && {
                  value: filterToggleState[filter.filterKey] | async
                };
                as toggleState
              ) {
                <div class="complex-filter__filter">
                  @if (filter.title) {
                    <div
                      class="complex-filter__filter__heading"
                      (click)="filter.collapsible && toggleFilter(filter.filterKey, !toggleState.value)"
                    >
                      <span class="complex-filter__filter__title">
                        <ftr-icon
                          class="complex-filter__filter__icon"
                          [icon]="filter.icon"
                          align="Middle"
                          size="Large"
                          gapRight="Regular"
                        ></ftr-icon>
                        <span>{{ isObservable(filter.title) ? (filter.title | async) : filter.title }}</span>
                      </span>
                      <div class="complex-filter__filter__heading-right">
                        <ng-container *ngTemplateOutlet="filterCount; context: { $implicit: filter }"></ng-container>
                        @if (filter.collapsible) {
                          <button
                            ftrButton
                            [displayType]="buttonDisplayType.Icon"
                            [title]="toggleState.value ? 'Collapse' : 'Expand'"
                            class="complex-filter__filter__collapse"
                          >
                            <ftr-icon
                              [icon]="toggleState.value ? 'KeyboardArrowUp' : 'KeyboardArrowDown'"
                              align="Middle"
                              size="Large"
                            ></ftr-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                  <div class="complex-filter__filter__content" [hidden]="filter.collapsible && !toggleState.value">
                    @switch (filter.type) {
                      @case ('radio-list') {
                        <ng-container *ngTemplateOutlet="radioList; context: { $implicit: filter }"></ng-container>
                      }
                      @case ('checkbox-list') {
                        <ng-container *ngTemplateOutlet="checkboxList; context: { $implicit: filter }"></ng-container>
                      }
                      @case ('checkbox-tree') {
                        <ng-container *ngTemplateOutlet="checkboxTree; context: { $implicit: filter }"></ng-container>
                      }
                      @case ('date-radio-list') {
                        <ng-container *ngTemplateOutlet="dateRadioList; context: { $implicit: filter }"></ng-container>
                      }
                      @case ('date') {
                        <ng-container *ngTemplateOutlet="date; context: { $implicit: filter }"></ng-container>
                      }
                      @case ('date-range') {
                        <ng-container *ngTemplateOutlet="dateRange; context: { $implicit: filter }"></ng-container>
                      }
                    }
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="complex-filter__footer">
    <button ftrButton [color]="buttonColor.Secondary" [fullWidth]="true" (click)="clearAll()">Clear All</button>
    <button ftrButton [fullWidth]="true" (click)="applyFilters()">
      <ftr-icon icon="Done" align="Top" gapRight="Small"></ftr-icon>
      <span>Apply Filters</span>
    </button>
  </div>
</div>

<ng-template #radioList let-filter>
  <ftr-complex-filter-radio-list
    [filter]="filter"
    (filterChanged)="registerFilterChange($event)"
    [visibilityToggled]="visibilityToggled"
  ></ftr-complex-filter-radio-list>
</ng-template>

<ng-template #checkboxList let-filter>
  <ftr-complex-filter-checkbox-list
    [filter]="filter"
    (filterChanged)="registerFilterChange($event)"
    [toggled]="filterToggleState[filter.filterKey]"
    [visibilityToggled]="visibilityToggled"
    [applyImmediately]="applyImmediately"
    [nestingDisplayMode]="nestingDisplayMode"
  ></ftr-complex-filter-checkbox-list>
</ng-template>

<ng-template #checkboxTree let-filter>
  <ftr-complex-filter-checkbox-tree
    [filter]="filter"
    (filterChanged)="registerFilterChange($event)"
    [toggled]="filterToggleState[filter.filterKey]"
    [visibilityToggled]="visibilityToggled"
    [applyImmediately]="applyImmediately"
    [nestingDisplayMode]="nestingDisplayMode"
  ></ftr-complex-filter-checkbox-tree>
</ng-template>

<ng-template #dateRadioList let-filter>
  <ftr-complex-filter-date-radio-list
    [filter]="filter"
    (filterChanged)="registerFilterChange($event)"
    [visibilityToggled]="visibilityToggled"
  ></ftr-complex-filter-date-radio-list>
</ng-template>

<ng-template #date let-filter>
  <ftr-complex-filter-date
    [filter]="filter"
    (filterChanged)="registerFilterChange($event)"
    [visibilityToggled]="visibilityToggled"
  ></ftr-complex-filter-date>
</ng-template>

<ng-template #dateRange let-filter>
  <ftr-complex-filter-date-range
    [filter]="filter"
    (filterChanged)="registerFilterChange($event)"
    [visibilityToggled]="visibilityToggled"
  ></ftr-complex-filter-date-range>
</ng-template>

<ng-template #filterCount let-filter>
  @if (isMultiSelectFilter(filter) && filtersApplied(filter.filterKey)) {
    <span class="complex-filter__filter__count">{{ filtersApplied(filter.filterKey) }}</span>
  }
</ng-template>
